const STORAGE_KEY = "readzh_visitor_id";

/**
 * ランダムなIDを生成する（crypto.randomUUID() のフォールバック用）
 */
function generateRandomId(): string {
  const chars = "abcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  for (let i = 0; i < 32; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}

/**
 * Visitor ID を取得する
 * localStorage に保存されていれば返し、なければ新規生成して保存する
 * 常に非空文字列を返す
 */
export function getVisitorId(): string {
  try {
    const existing = localStorage.getItem(STORAGE_KEY);
    if (existing && existing.length > 0) {
      return existing;
    }

    let newId: string;
    if (
      typeof crypto !== "undefined" &&
      typeof crypto.randomUUID === "function"
    ) {
      newId = crypto.randomUUID();
    } else {
      newId = generateRandomId();
    }

    localStorage.setItem(STORAGE_KEY, newId);
    return newId;
  } catch {
    // localStorage が使えない環境でも例外を飲み込み、必ず文字列を返す
    return generateRandomId();
  }
}
